import { graphql } from '@/lib/graphql';

export const FlowTemplatesSubscription = graphql(`
  subscription SystemFlowTemplates {
    flowTemplates(orderBy: [{ featured: DESC }, { sortOrder: ASC }]) {
      id
      name
      category
      featured
      sortOrder
      variables
      nodes
    }
  }
`);

export const FlowTemplateSubscription = graphql(`
  subscription SystemFlowTemplate($id: Uuid!) {
    flowTemplatesByPk(id: $id) {
      id
      name
      description
      category
      featured
      sortOrder
      variables
      flowName
      flowDescription
      nodes
      edges
      entryNodeId
      voiceConfig
    }
  }
`);

export const InsertFlowTemplateMutation = graphql(`
  mutation InsertFlowTemplate($object: FlowTemplatesInsertInput!) {
    insertFlowTemplatesOne(object: $object) {
      id
    }
  }
`);

export const UpdateFlowTemplateMutation = graphql(`
  mutation UpdateFlowTemplate($id: Uuid!, $set: FlowTemplatesSetInput!) {
    updateFlowTemplatesByPk(pkColumns: { id: $id }, _set: $set) {
      id
    }
  }
`);

export const DeleteFlowTemplateMutation = graphql(`
  mutation DeleteFlowTemplate($id: Uuid!) {
    deleteFlowTemplatesByPk(id: $id) {
      id
    }
  }
`);

export const ImportOrganizationsQuery = graphql(`
  query FlowTemplateImportOrganizations {
    organizations(orderBy: { name: ASC }) {
      id
      name
    }
  }
`);

export const ImportFlowsQuery = graphql(`
  query FlowTemplateImportFlows($organizationId: Uuid!) {
    flows(where: { organizationId: { _eq: $organizationId }, deletedAt: { _isNull: true } }, orderBy: { name: ASC }) {
      id
      name
      nodes
    }
  }
`);

export const ImportFlowSnapshotQuery = graphql(`
  query FlowTemplateImportFlowSnapshot($id: Uuid!) {
    flowsByPk(id: $id) {
      id
      name
      description
      nodes
      edges
      entryNodeId
      voiceConfig
    }
  }
`);
